export default __webpack_public_path__ + "static/media/@streamfather.22138fc4.jpeg";